import { groupBy, sortBy, uniqBy } from "lodash";
import { usePreloadStore } from "@/Tailwind/Stores/preload";

export const useUsers = (tenantIds) => {
    const preloadStore = usePreloadStore();
    let propUsers = preloadStore.users;

    const groupedUsers = Object.entries(groupBy(propUsers, "id")).map(
        ([id, tenantUser]) => ({
            id,
            tenantIds: tenantUser.flatMap((tenantUser) => tenantUser.tenants),
        })
    );

    let users = Object.entries(uniqBy(propUsers, "id")).map(
        ([id, tenantUser]) => ({
            id,
            ...tenantUser,
        })
    );

    users.forEach((user, index) => {
        const res = groupedUsers.find((gUser) => gUser.id === user.id);

        users[index] = {
            ...user,
            ...res,
        };
    });

    if (Array.isArray(tenantIds)) {
        users = users.filter((user) =>
            tenantIds.every((tenantId) => user.tenantIds.includes(tenantId))
        );
    }

    if (!Array.isArray(tenantIds) && tenantIds) {
        users = users.filter((user) => user.tenantIds.includes(tenantIds));
    }

    return sortBy(users, "fullname");
};
